import {
  BreakLine,
  EmptyInput,
  InputGroup, InputRow, ModelInput,
  ModelNewNumericInput,
  RadioYesNoInput,
} from '@equifinance/shared';
import { BrokerDetailGenericSection } from '../../../components/BrokerDetailGenericSection';

export const brokerageDetailsRefName = 'brokerage-details';

export default function BrokerageDetailsSection() {
  return (
    <BrokerDetailGenericSection
      id={brokerageDetailsRefName}
      refName={brokerageDetailsRefName}
      title="Brokerage details"
      level={1}
    >
      <InputGroup>
        <InputRow>
          <ModelInput
            label="FCA number"
            field="companyDetails.fcaNumber"
            required
          />
          <ModelInput
            label="Registered company name"
            field="companyDetails.registeredCompanyName"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Trading company name"
            field="companyDetails.tradingCompanyName"
            required
          />
          <ModelInput
            label="Registered company number"
            field="companyDetails.companyRegistrationNumber"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="ICO number"
            field="companyDetails.icoNumber"
            required
          />
          <ModelInput
            label="Insurance provider"
            field="companyDetails.professionalIndemnity"
            tooltip="Insurance provider"
          />
        </InputRow>

        <InputRow>
          <ModelNewNumericInput
            label="Level of cover (if applicable)"
            field="companyDetails.levelOfCover"
            required
            prefix="£"
          />
          <ModelInput
            label="Company contact number"
            field="companyDetails.telephoneNumber"
            required
            tooltip="This should be the main office telephone number, and will appear on the ESIS"
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Company email address"
            field="companyDetails.emailAddress"
            required
            tooltip="This should be the main company email address, and will appear on the ESIS"
          />
          <RadioYesNoInput
            label="Permission to advise on regulated mortgage contracts?"
            field="companyDetails.hasRegulatoryPermission"
            required
          />
        </InputRow>

        <InputRow>
          <ModelInput
            label="Company web address"
            field="companyDetails.webAddress"
            required
            tooltip="This should be the main company Web Address, and will appear on the ESIS"
          />
          <EmptyInput />
        </InputRow>

        <BreakLine small />

        <InputRow>
          <ModelInput
            label="Flat/ sub building number"
            field="companyDetails.address.subBuilding"
            required
          />
          <ModelInput
            label="House / building number"
            field="companyDetails.address.houseNumber"
            required
          />
        </InputRow>
        <InputRow>
          <ModelInput
            label="House / building name"
            field="companyDetails.address.houseName"
            required
          />
          <ModelInput
            label="Street"
            field="companyDetails.address.street"
            required
          />
        </InputRow>
        <InputRow>
          <ModelInput
            label="Town / city"
            field="companyDetails.address.postTown"
            required
          />
          <ModelInput
            label="Postcode"
            field="companyDetails.address.postCode"
            required
          />
        </InputRow>
      </InputGroup>
    </BrokerDetailGenericSection>
  );
}
